<template>
  <div style="position: absolute;width: 100%;height: 100%;display: flex;justify-content: space-between">
    <div class="loading">
      <div>
        <img :src="u.config().static+'/homeadmin/image/loading.png'"/>
      </div>
    </div>

    <!--左侧导航-->
    <div class="box-left about">
      <!--  -->
      <div style="width: 219px;text-align: center;background-color: #FFFFFF;font-weight: bold;font-size: 16px;color: #2E6CFF;height: 40px;line-height: 40px"
           class="left-title">
        {{ systeminfo.minsystemName }}
        <!--        <img :src="u.config().static+'/'+writelogo" style="width: 80%;cursor: pointer;margin: 20px 0">-->
      </div>
      <div style="height: 10px"></div>
      <el-input size="mini" style="width: 80%;margin-left: 10%;" v-model="find" @input="find_data"></el-input>
      <el-menu @select="select"
               size="mini"
               text-color="#000000"
               unique-opened
               active-text-color="#2E6CFF"
               style="height:calc( 100% - 136px);overflow-x: hidden;">
        <el-submenu v-for="(item,index) in list" :key="index+'i'" :index="index+1+''">
          <template slot="title">
            <i :class="item.icon" style="color: #000000"></i>
            <span slot="title">{{ item.name }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item v-for="(item2,index2) in item.nav" :key="index2+'u'" :index="(index+1)+'-'+(index2+1)">{{ item2.name }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
      <div style="height: 50px;line-height: 50px;text-align: center">

        <el-button type="danger" size="mini" @click="logout"
                   style="font-size: 14px;width: 200px;height: 43px;border:0; background-color:#000000;border-radius: 8px ;">退出登录
        </el-button>

      </div>

    </div>
    <!--右边页面-->

    <div class="box-right" v-if="cardlist.length>0" id="right_body">

      <!--右边主体内容-->
      <div class="right-bottonm" id="right">
        <!--        顶部菜单栏-->
        <el-tabs @edit="handleTabsEdit" @tab-click="handleTabschange" v-model="activeName" id="title_tab"
                 style="height: 100%;">

          <el-tab-pane v-for="(item,index) in cardlist" :name="item.path" :label="item.name" :key="item.key"
                       style="height: 100%;">

            <span slot="label" :id="'tab-'+index">
              {{ item.name }}&nbsp;&nbsp;<i class="el-icon-close" @click="close_one_tab(index)"></i></span>
            <compoment :path="item.path" :menudata="item" :is="nav_tab[item.path].default"></compoment>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!--右边页面没有选择任何都东西情况-->
    <div class="box-right" v-else>
      <div class="loading">

        <div>
          <img style="margin-right: 300px;" src="../assets/image/loading.png"/>
        </div>
      </div>
      <!--右边主体内容-->
      <div class="right-bottonm" id="right">
        <!--        没有打开任何菜单的时候显示-->

        <div
          style="box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.08);height: 40px;font-size: 20px;font-weight: 500;line-height: 40px;padding:0 20px;display: flex;justify-content: space-between;">
          <div>首页</div>
          <!--          <div>{{ userinfo.name }}</div>-->
        </div>

        <div style="height: calc( 100% - 40px);overflow-y:auto ">
          <div style="height:60px;">
            <el-alert
              :closable="false"
              title="温馨提示:依照国家法律法规的规定，商家需依法办理市场主体登记或税务登记，并依法履行纳税义务，若您已履行，可自行忽略"
              type="warning">
            </el-alert>

          </div>
          <div style="color: #999999;font-size: 24px;font-weight: 500;padding-left: 60px">您好，欢迎使用</div>

          <div style="height:25px"></div>


          <div style="padding-left: 60px;display: flex">

            <div style="width: 30%;height:247px ;box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.08);border-radius: 8px;padding:25px">
              <div style="display: flex;align-items: center">
                <img src="../assets/image/usericon.png" style="width: 74px;height: 74px">
                <div style="margin-left: 15px;font-size: 26px;font-weight: 500;">
                  {{ systeminfo.systemName }}
                </div>

              </div>

              <div style="height: 25px"></div>
              <div style="height: 25px"></div>
              <div style="padding-left: 90px">
              </div>

            </div>

            <div
              style=";width: 60%;height: 297px;background: linear-gradient( 90deg, #6A63FE 0%, #1C96FE 100%);box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.08);border-radius: 8px 8px 8px 8px;margin-left: 20px;display: flex;justify-content: space-evenly;align-items: center">

              <div style="height: 112px;border-right: solid 1px #FFFFFF;padding-right:60px;text-align: center">
                <div style="font-size: 20px;color: #FFFFFF;">总流水（元）</div>
                <div style="height: 48px"></div>
                <div style="color: #FFFFFF;font-size: 26px">{{ ontdata.all || 0 }}</div>
              </div>

              <div style="height: 112px;border-right: solid 1px #FFFFFF;padding-right:60px;text-align: center">
                <div style="font-size: 20px;color: #FFFFFF;">总笔数（条）</div>
                <div style="height: 48px"></div>
                <div style="color: #FFFFFF;font-size: 26px">{{ ontdata.alllist || 0 }}</div>
              </div>

              <div style="height: 112px;border-right: solid 1px #FFFFFF;padding-right:60px;text-align: center">
                <div style="font-size: 20px;color: #FFFFFF;">佣金（元）</div>
                <div style="height: 48px"></div>
                <div style="color: #FFFFFF;font-size: 26px">{{ ontdata.income || 0 }}</div>
              </div>

              <div style="height: 112px;text-align: center">
                <div style="font-size: 20px;color: #FFFFFF;">已结算金额（元）</div>
                <div style="height: 48px"></div>
                <div style="color: #FFFFFF;font-size: 26px">{{ ontdata.incomeno || 0 }}</div>
              </div>
            </div>
          </div>
          <div style="height: 25px"></div>
          <div style="padding-left: 60px;display: flex;align-items: center">
            <div style="font-size: 24px;color: #000000;font-weight: 500;">统计数据</div>
          </div>
          <div style="box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.08); margin:40px ;padding:20px">

            <div style="display: flex;">

              <div class="datacardm" v-for="(item,index) in activedata" :style="selectindex==index?'color:#2E6CFF':''"
                   @click="selectdata(item.type);selectindex=index">{{ item.label }}
              </div>
              <div>
                <el-date-picker
                  v-if="selectindex==2"
                  v-model="selectoimesanshi"
                  type="daterange"
                  value-format="timestamp"
                  range-separator="至"
                  start-placeholder="开始日期"
                  size="mini"
                  @change="getIndexlist"
                  style="margin-left: 40px"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>
            <div id="chartDataThird" style="width: 100%;height: 400px"></div>

          </div>
        </div>


      </div>
    </div>
    <!--  右键菜单-->
    <div :class="right_move_class" :style="right_move_style">
      <div class="right_menu_item" @click="reload_one">&nbsp;&nbsp;&nbsp;&nbsp;刷新&nbsp;</div>
      <div class="right_menu_item" @click="close_one">&nbsp;&nbsp;&nbsp;&nbsp;关闭&nbsp;</div>
      <div class="right_menu_item" @click="close_other">&nbsp;&nbsp;&nbsp;&nbsp;关闭其他&nbsp;</div>
      <div class="right_menu_item" @click="close_all">&nbsp;&nbsp;&nbsp;&nbsp;关闭所有&nbsp;</div>
      <div class="right_menu_item" @click="move_left">&nbsp;&nbsp;&nbsp;&nbsp;移到最左侧&nbsp;&nbsp;&nbsp;&nbsp;</div>
    </div>
  </div>
</template>

<script>

import u from "../assets/js/util"


var vm

//组件填写
var select_tap = ""
export default {
  components: this.nav_tab,
  data() {
    return {
      isagent: false,
      u,
      find: "",
      move_index: 0,
      nav_tab: {},
      cardlist: [],
      right_move_class: "right_menu",
      right_move_style: "",
      activeName: "",
      title_name: "",
      select_name: "",
      select_path: "", //默认打开页面
      list: [],
      re_list: [],
      systeminfo: {},
      userinfo: {},
      writelogo: "",
      activedata: [
        {type: 7, label: "近7天"},
        {type: 30, label: "近30天"},
        {type: 0, label: "自定义"}
      ],
      selectindex: 0,
      selectoimesanshi: [],
      ontdata: {
        all: 0,
        alllist: 0,
        income: 0,
        incomeno: 0,
      }
    }
  },
  name: "indexhome",

  async mounted() {

    var host = location.host
    var systeminfo = await u.get_no("admin", "getsysteminfo", host)
    if (systeminfo) {
      this.systeminfo = systeminfo
      document.title = systeminfo.systemName
      if (systeminfo.writelogo) {
        this.writelogo = systeminfo.writelogo[0]
      }
    }

    vm = this
    var address = await u.post("users", "get_address", {})

    if (address === false) {
      return
    }
    if (address !== false) {
      try {
        window.city = address.content.address_detail.city
        window.point = address.content.point
      } catch (e) {

      }
    }
    var userinfo = await u.post("users", "getuserinfo", {})
    window.userinfo = userinfo
    this.userinfo = userinfo
    var _this = this
    if (userinfo.nav) {
      this.list = userinfo.nav
      this.re_list = userinfo.nav

      //动态添加组件
      for (var i = 0; i < userinfo.nav.length; i ++) {
        if (userinfo.nav) {
          var item = userinfo.nav[i]
          for (var j = 0; j < item.nav.length; j ++) {
            await this.setmodus(item.nav[j].path, item.nav[j].url)
          }
        }
      }
    }
    window.onkeydown = (event) => {

      if (!event || !event.isTrusted || !event.cancelable) {
        return
      }

      const key = event.key
      if (key === 'F5') {

        if (_this.cardlist.length != 0) {

          for (var i = 0; i < _this.cardlist.length; i ++) {

            if (_this.cardlist[i].path == _this.activeName) {
              _this.cardlist[i].key = _this.activeName + Math.random()
            }

          }
          event.preventDefault()
          event.returnValue = false
        }
      }
    }


    setTimeout(() => {

      this.isagent = window.isagent
      this.$forceUpdate()
    })
    setInterval(() => {
      u.post("users", "ping", {}, false, false)
    }, 30000)

    var todayEndTime = new Date(new Date().setHours(23, 59, 59, 999)).getTime()
    var todayStartTime = todayEndTime - 1000 * 60 * 60 * 24 * 7
    var time = [todayStartTime, todayEndTime]
    setTimeout(() => {
      this.getalldatas()
      this.getIndexlist(time)
    }, 500)
  },
  methods: {


    async getalldatas() {
      var sums = await u.post("admin", "getIndexsums", {isagent: isagent})
      this.ontdata.all = sums.all
      this.ontdata.alllist = sums.alllist
      this.ontdata.income = sums.income
      this.ontdata.incomeno = sums.incomeno
    },
    selectdata(type) {

      var time = []

      switch (type) {
        case 7:
          var todayEndTime = new Date(new Date().setHours(23, 59, 59, 999)).getTime()
          var todayStartTime = todayEndTime - 1000 * 60 * 60 * 24 * 7
          time = [todayStartTime, todayEndTime]
          this.getIndexlist(time)
          break
        case 30:
          var todayEndTime = new Date(new Date().setHours(23, 59, 59, 999)).getTime()
          var todayStartTime = todayEndTime - 1000 * 60 * 60 * 24 * 30
          time = [todayStartTime, todayEndTime]
          this.getIndexlist(time)
          break
      }


    },

    async getIndexlist(time) {
      var list = await u.post("admin", "getIndexlist", {time: time, isagent: isagent})

      var rlist = {}
      for (var i = 0; i < list.length; i ++) {
        var dt = u.formatDateTime(2, list[i].add_time)
        if (rlist[dt]) {
          var nums = (Number(rlist[dt]) + Number(list[i].amount)).toFixed(2)
          rlist[dt] = nums
        } else {
          rlist[dt] = list[i].amount
        }
        if (i == list.length - 1) {
          rlist[dt] = rlist[dt]
        }
      }


      // var arrlist = getDatesBetween(time[0], time[1])
      // for (var i = 0; i < arrlist.length; i ++) {
      //   if (!rlist[arrlist[i]]) {
      //     rlist[arrlist[i]] = 0
      //   }
      //
      // }
      //
      // console.log(Object.keys(rlist))
      //
      var dtlist = []
      var sumlist = []

      for (var rlistKey in rlist) {
        dtlist.push(rlistKey)
        sumlist.push(rlist[rlistKey])
      }

      this.getecharsdata(dtlist, sumlist)
    },

    /**
     * 获取首页内容
     */

    getecharsdata(dtlist, sumlist) {

      var myChart = this.$echarts.init(document.getElementById('chartDataThird'));

      var option = option = {
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: dtlist
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            label: {
              show: true,
              position: 'top'
            },
            data: sumlist,
            type: 'line'
          }
        ]
      };
      option && myChart.setOption(option);

    },


    /**
     * 根据后端设置配置前端组件
     * @param path
     * @param url
     * @returns {Promise<unknown>}
     */
    setmodus(path, url) {
      var _this = this
      return new Promise((r, e) => {

        import('./module/' + url ).then((data) => {
          _this.nav_tab[path] = data
          r()
        })
      })
    },
    logout() {
      this.$confirm('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        delCookie("AUTH")
        this.$router.push('/')
      }).catch(() => {

      });
    },
    find_data(e) {

      var linshilist = []
      this.re_list.forEach((item) => {
        if (item.name.indexOf(e) != - 1) {
          linshilist.push(item)
        }

      })
      this.list = linshilist
    },
    //关闭全部
    close_all(e) {
      this.cardlist = []
    },
    //移动到左侧
    move_left(e) {
      var one = this.cardlist[select_tap]
      this.cardlist.splice(select_tap, 1)
      this.cardlist.unshift(one)
    },  //关闭其他
    close_other(e) {
      this.cardlist = [this.cardlist[select_tap]]
    }, //刷新
    reload_one(e) {
      this.cardlist[select_tap].key = Math.random().toString()
    },

    close_one_tab(index) {

      var select_tap = index

      this.cardlist.splice(select_tap, 1)

      if (select_tap > 0) {
        this.activeName = this.cardlist[select_tap - 1].path

        window.select_path = this.cardlist[select_tap - 1].path


        setcokiedata(this.cardlist[select_tap - 1])

      } else {
        if (this.cardlist.length > 0) {
          this.activeName = this.cardlist[select_tap].path
          window.select_path = this.cardlist[select_tap].path

          setcokiedata(this.cardlist[select_tap])


        }
      }

      if (select_tap > 0) {


        this.select_name = this.cardlist[select_tap - 1].name
        this.select_path = this.cardlist[select_tap - 1].path
        window.select_path = this.select_path
        this.activeName = this.cardlist[select_tap - 1].path

        setcokiedata(this.cardlist[select_tap - 1])

      } else {

        setcokiedata()
      }
    },
    //关闭当前
    close_one(e) {

      this.cardlist.splice(select_tap, 1)

      if (select_tap > 0) {
        this.activeName = this.cardlist[select_tap - 1].path

        window.select_path = this.cardlist[select_tap - 1].path
        setcokiedata(this.cardlist[select_tap - 1])
      } else {
        if (this.cardlist.length > 0) {
          this.activeName = this.cardlist[select_tap].path
          window.select_path = this.cardlist[select_tap].path
          setcokiedata(this.cardlist[select_tap])
        }
      }

      if (select_tap > 0) {


        this.select_name = this.cardlist[select_tap - 1].name
        this.select_path = this.cardlist[select_tap - 1].path
        window.select_path = this.select_path
        this.activeName = this.cardlist[select_tap - 1].path

        setcokiedata(this.cardlist[select_tap - 1])

      } else {

        setcokiedata()

      }
    },
    handleTabschange(e, event) {


      window.select_path = this.cardlist[e.index].path

      setcokiedata(this.cardlist[e.index])

    },
    handleTabsEdit(e) {
      for (var i = 0; i < this.cardlist.length; i ++) {
        if (this.cardlist[i].path == e) {
          this.cardlist.splice(i, 1)
          if (i > 0) {
            this.select_name = this.cardlist[i - 1].name
            this.select_path = this.cardlist[i - 1].path
            window.select_path = this.select_path
            this.activeName = this.cardlist[i - 1].path

            setcokiedata(this.cardlist[i - 1])
          }
          break
        }
      }
    },
    select(data) {
      var sum = data.split("-")
      this.title_name = this.list[Number(sum[0]) - 1].name
      var select = this.list[Number(sum[0]) - 1].nav[Number(sum[1]) - 1]
      for (var i = 0; i < this.cardlist.length; i ++) {
        if (this.cardlist[i].path == select.path) {
          this.activeName = select.path
          setcokiedata(select)
          return
        }
      }


      setcokiedata(select)
      this.select_name = select.name
      this.select_path = select.path
      window.select_path = this.select_path

      var carddata = select


      this.$set(carddata, 'key', select.path + Math.random().toString())
      this.cardlist.push(carddata)

      this.activeName = select.path
    }
  }
}

function setcokiedata(obj) {

  if (obj.url.indexOf("oem/") != - 1) {

    const customEvent = new CustomEvent('tabupdate', {
      detail: obj,
      bubbles: true, // 允许事件冒泡
      cancelable: false // 不允许阻止事件
    });
    document.dispatchEvent(customEvent);
    return
  }
  if (!obj) {
    u.setCookie("module", "public")
    u.setCookie("server", "public")
    u.setCookie("identifying", "")
  } else {

    u.setCookie("module", obj.module)
    u.setCookie("table_name", obj.name)
    u.setCookie("server", obj.server)
    u.setCookie("identifying", obj._id)
  }

}


document.onclick = function (e) {
  if (vm && vm.right_move_class) {
    vm.right_move_class = "right_menu"
  }
}
document.oncontextmenu = function (e) {
  var id = e.target.id
  if (!id) {
    return
  }
  select_tap = Number(id.split("-")[1])
  // var i = 0;
  // while ((child = child.previousSibling) != null) i ++;
  // select_tap = i
  if (id.indexOf("tab-") != - 1) {
    vm.right_move_class = "right_menu right_menu_active"
    vm.right_move_style = `left:${e.pageX}px;top:${e.pageY}px;z-index:999`
    e.stopPropagation();
    return false
  } else {
    vm.right_move_class = "right_menu"
  }

};     //禁止鼠标右键菜单显示

function getDatesBetween(startDate, endDate) {
  let dateArray = [];
  let currentDate = new Date(startDate);

  // 确保endDate晚于或等于startDate
  if (endDate < startDate) {
    [startDate, endDate] = [endDate, startDate];
  }

  // 将日期推入数组，直到currentDate大于endDate
  while (currentDate <= endDate) {
    // 使用Date对象的特定格式（如YYYY-MM-DD）将日期转换为字符串
    // 这里我们使用的是toLocaleDateString，但你可能需要根据你的需求调整它
    dateArray.push(u.formatDateTime(2, currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dateArray;
}

function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

function getCookie(name) {
  let arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
  if (arr != null) return unescape(arr[2]);
  return null;
}

</script>

<style scoped>
.right_menu {
  display: none;
  padding: 3px 0;
  font-size: 14px;
  border: solid 1px #efefef;
  background-color: #FFFFFF;
  position: absolute;
}

.right_menu_active {
  display: block;
}

.right_menu_item {
  cursor: default;
}

.right_menu_item:hover {

  background-color: #efefef;
  cursor: pointer;

}

.box-left {
  width: 220px;
  height: 100%;
  border-right: 1px #e6e6e6 solid;
}

.box-right {
  width: 100%;
  padding: 0;
  /*width: calc(100% - 210px);*/
  /*background-color: #efefef;*/
  /*background-size: 100% 100%;*/
  /*background-repeat: no-repeat;*/

}


.right-bottonm {
  height: 100%;
  margin: 0 auto;
  border-radius: 1px;
}

.left-title {
  /*background-image: url("../../assets/logo.png");*/
  /*background-size: 100% 100%;*/
}

.about >>> .el-menu-item:hover {
}

.about >>> .el-submenu__title:hover {
}

.about >>> .el-menu::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

.about >>> .el-menu {
  border-right: solid 0px #e6e6e6;
}

.box-right >>> .el-tabs__header {
  padding: 0;
  margin: 0;

}

.box-right >>> .el-tabs__active-bar {
  display: none;

}

.box-right >>> .el-tabs__item {
  padding: 0px 10px;
  border-radius: 4px;
  user-select: none;
  height: 30px;
  line-height: 30px;
  margin: 5px 2px;
}


.box-right >>> .el-tabs--top .el-tabs__item.is-top:last-child {
  padding: 0px 10px;
  border-radius: 4px;
  user-select: none;
  margin: 5px 2px;
}


.box-right >>> .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding: 0px 10px;
  border-radius: 4px;
  user-select: none;
  margin: 5px 2px;
}


.box-right >>> .tab-customer {
  user-select: none;

}

.box-right >>> .el-tabs__content {
  height: 100%;
  position: absolute;
  width: calc(100% - 219px);

}


.box-right >>> .el-tabs__nav-wrap::after {
  height: 0px;

}

.box-right >>> .el-tabs__nav-scroll {
  background: #efefef;
}

.box-right >>> .el-tabs__item {
  background: #ffffff;
}

.box-right >>> .el-tabs__item .el-icon-close {
  margin-left: 0;

}

.loading {

  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99999;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: rgba(100, 100, 100, 0.1);
  display: none;

}

.loading img {

  -webkit-animation: rotate 1.0s linear infinite;
}

/deep/ .el-submenu__title i {
  color: #000000;

}

/deep/ .el-menu-item.is-active {
  background: rgba(46, 108, 255, 0.36);

}

/deep/ .el-tabs__item.is-active {
  color: #2e6cff;

}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg); /* IE 9 */
    -moz-transform: rotate(0deg); /* Firefox */
    -o-transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
    -ms-transform: rotate(360deg); /* IE 9 */
    -moz-transform: rotate(360deg); /* Firefox */
    -o-transform: rotate(360deg);
  }
}

@-webkit-keyframes rotate {
  0% {
    -moz-transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(360deg);
  }
}

.datacardm {
  cursor: pointer;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 30px;
}

.datacardm-active {
  color: #2E6CFF;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue